import { defineMessages } from 'react-intl';

const messages = defineMessages({
    moduleLearningObjectives: {
        id:'moduleLearningObjectives',
        defaultMessage: 'Learning Objectives',
        description: 'Heading for list of module learning objectives',
    },
});

export default messages;
